import React from 'react';
import styled from 'styled-components';
import {useMedia} from "react-use";

const CheckOutItem = (props) => {
    const isMobile = useMedia("(max-width: 992px)");

    const BorderRadius = {
        upperBorderRadius: "10px 10px 0px 0px",
        noBorderRadius: "0px",
        lowerBorderRadius: "0px 0px 10px 10px",
        borderRadius: "10px"
    }

    const BackgroundColor = {
        cadet: "#36686A",
        white: "#F3F3F3",
        black: "#000000"
    }

    const CheckoutContainer = styled.div.attrs((props) => ({
        variant : props
    }))`
    padding: 25px 0 25px 20px;
    background: ${({variant}) => BackgroundColor[variant.background]};
    border-radius: ${({variant}) => BorderRadius[variant.borderRadius]};
    color: ${({variant}) => BackgroundColor[variant.color]};
    `;

    const mobile = <section className={`checkout-cart darkGreenBlue m-2`}>
                        <CheckoutContainer className="row p-0 p-4" borderRadius={props.borderRadius} background={props.background}>
                            <div className="col-xs-12 col-lg-9 font-medium-x-large">
                                <div className="d-flex flex-column">
                                    <h3 className={`font-medium-x-large m-0 bold ${props.fontColor ? props.fontColor !=='color-white' ? 'color-indigo': props.fontColor: 'color-indigo'}`}>
                                        {props.title}
                                    </h3>
                                    <div className="font-medium-x-large light">
                                        {props.plan}
                                    </div>
                                </div>
                            </div>
                            <div className={`col-xs-12 col-lg-3 text-right  font-size-30 medium-bold ${props.fontColor ? props.fontColor !=='color-white' ? 'color-indigo': props.fontColor: 'color-indigo'}`}>
                                {props.price}
                            </div>
                            <div className="col-xs-12 text-right font-small light">
                                {props.promotion}
                            </div>
                        </CheckoutContainer>
                    </section>

    const desktop = <section className={`checkout-cart m-2`}>
                        <CheckoutContainer className="row" borderRadius={props.borderRadius} background={props.background} color={props.color ? props.color: "black"}>
                            <div className="col-xs-10 col-lg-7 font-medium-x-large">
                                <div className="d-flex flex-column">
                                    <h3 className={`font-medium-x-large m-0 bold ${props.fontColor ? props.fontColor: ''}`}>
                                        {props.title}
                                    </h3>
                                    <div className="font-medium-x-large light">
                                        {props.plan}
                                    </div>
                                </div>
                            </div>
                            <div className={`col-lg-5 text-right pr-lg-3 font-size-30 ${props.fontColor ? props.fontColor: 'color-indigo'}`}>
                                {props.price}
                                <div className="text-right font-tiny light">
                                    {props.promotion}
                                </div>
                            </div>

                        </CheckoutContainer>
                    </section>

    return (
       isMobile ? mobile: desktop
    );
}

export default CheckOutItem;


// WEBPACK FOOTER //
// ./resources/assets/js/flipToFibre/orderSummary/CheckOutItem.js